import { ApiProvider } from "@/providers/api-provider";

class ActivityLogApiProvider extends ApiProvider {
  async getData(params = null): Promise<[] | null> {
        const response = await this.get(`/activity-logs?${params}`);
    return response.data;
  }
}

export const activityLogApiProvider = new ActivityLogApiProvider();
